<template>
  <div v-if="user.userType != '00'" style="width: 100%;height: 30px;display: flex;font-size: 13px;">
    <div  style="width: 100%;height: 30px;display: flex;">
      <div style="margin: auto 0;color: #595a5a"><span>当前位置：</span></div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="margin: auto 0;font-size: 13px"
      >
        <el-breadcrumb-item
          @click.native="handleJump(item)"
          v-for="(item, index) in levelList"
          :key="index"
          :class="index == levelList.length - 1 ? 'text-color' : null"
        >
          {{ item.meta.title }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "Breadcrumb",
  data() {
    return {
      levelList: null,
    }
  },
  watch: {
    $route(route) {
      this.getBreadcrumb()
    },
  },
  created() {
    this.getBreadcrumb()
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    getBreadcrumb() {
      let pId = this.$route.query.pId
      let collId = this.$route.query.collId

      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      )
      let array = []
      matched.map((record) => {
        array.push({
          meta: {
            title: record.meta.title,
          },
        })
      })

      this.levelList = array.filter((item) => {
        if (item.meta && item.meta.title == "创建产品" && (pId || collId)) {
          item.meta.title = "编辑产品"
        }
        return item.meta && item.meta.title && item.meta.breadcrumb !== false
      })
    },
  },
}
</script>

<style scoped>
.text-color .el-breadcrumb__inner {
  color: rgb(20, 171, 244) !important;
}
</style>
